import type { AgentModuleConfig } from '@/context/agent-container.context';

/**
 * Layers a page-registered module on top of the always-available default
 * (`home`) module. The page keeps its identity (module, page, tools, header)
 * and adds page-relevant tools; the base still contributes its context (user,
 * navigable pages) and renders the shared tool results the page doesn't.
 * Page values win on collision.
 */
export function layerAgentModuleConfig(
  page: AgentModuleConfig | null,
  base: AgentModuleConfig | null,
): AgentModuleConfig | null {
  if (!page || !base) return page ?? base;
  return {
    ...page,
    getModuleContext: () => ({
      ...base.getModuleContext?.(),
      ...page.getModuleContext?.(),
    }),
    renderToolResult: (message, toolResult) =>
      page.renderToolResult?.(message, toolResult) ??
      base.renderToolResult?.(message, toolResult),
  };
}
